









































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import TimeZoneCard from "@/components/form/TimeZoneCard.vue";
import CommonInputModal from "@/components/common/CommonInputModal.vue";
import CommonButton from "@/components/common/CommonButton.vue";
import CommonInput from "@/components/common/CommonInput.vue";
import ChangeMapButton from "@/components/other/ChangeMapButton.vue";

@Component({
  components: {
    CommonInput,
    TimeZoneCard,
    CommonInputModal,
    CommonButton,
    ChangeMapButton
  },
})
export default class MapInput extends Vue {
  private isShow: boolean = false
  private locationName: string = '';
  private mapTypeId:string = 'roadmap';
  private isMarker:boolean = false;
  private marker:object = { lat: 45.508, lng: -73.587 };
  private center: object = { lat: 45.508, lng: -73.587 };
  private infoWinOpen:boolean = false;

  @Prop()
  private value!: string;

  @Prop()
  private label?: string;

  @Prop()
  private name?: string;

  @Prop()
  private rules?: Array<any>;

  @Prop()
  private lat?: number|null;

  @Prop()
  private lng?: number|null;

  @Prop({default: ''})
  private locName?: string;

  @Prop({default: ''})
  private errorMessage!: string;

  @Prop({default: false})
  private disabled!: boolean;

  @Prop({default: false})
  private dark!: boolean;

  @Prop()
  private color?: string;

  @Prop({default: false})
  private dense?: boolean;

  @Prop({default: true})
  private rounded?: boolean;

  @Watch('value')
  watchPropValue() {
    this.locationName = this.value;
  }

  @Watch('lat')
  watchPropLat() {
    this.marker = {
      lat: this.lat,
      lng: this.lng
    }
  }

  @Watch('lng')
  watchPropLng() {
    this.marker = {
      lat: this.lat,
      lng: this.lng
    }
  }

  private mounted() {
    if (this.lat && this.lng) {
      this.center = {lat: this.lat, lng: this.lng};
      this.marker = {lat: this.lat, lng: this.lng};
      this.locationName = this.value;
      this.isMarker = true;
      this.infoWinOpen = true;
    } else {
      this.geolocate();
    }
  }

  private changeShow(show:boolean) {
    this.isShow = show;
  }

  private geolocate() {
    navigator.geolocation.getCurrentPosition(position => {
      this.center = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      };
    });
  }

  private handleSelect() {
    this.isShow = false;
    if (this.isMarker) {
      this.$emit('location', {name: this.locationName || 'Location', position: this.marker})
    } else {
      this.$emit('location', false)
    }
  }

  private handleCancel() {
    this.marker = {lat: this.lat, lng: this.lng};
    this.isShow = false;
  }

  private handleMapClick(event: any) {
    this.marker = {
      lat: event.latLng.lat(),
      lng: event.latLng.lng()
    }
    this.infoWinOpen = true;
    this.isMarker = true;
  }

  private handleCloseMarket() {
    this.infoWinOpen= false
    this.isMarker = false;
  }
}
